export class Features {
  public static readonly PC_UNIFIED_ORDERS_PAGE = '2024_07_pcc_unified_orders_page';
  public static readonly UNIFIED_ORDERS_SCHEDULED_ACTIVATIONS = '2024_11_07_unified_orders_page_schedule_activation';
}
